module.exports = __webpack_public_path__ + "static/img/combinedValve.1ad7c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/combinedValve.png
// module id = +CB3
// module chunks = 1